import { FullConfiguration } from "@/types/crm/configuration/configuration"

export function fullConfigurationToColumnVisibilityObject(fullConfiguration: FullConfiguration) {
    // Create an array of [name, isRequired] pairs from all parameter types
    const parameterEntries = [
        ...(fullConfiguration?.parameter?.crm?.map((item) => [item.name, item.settings?.isRequiredForExport === true]) ?? []),
        ...(fullConfiguration?.parameter?.project?.map((item) => [item.name, item.settings?.isRequiredForExport === true]) ?? []),
        ...(fullConfiguration?.parameter?.survey?.map((item) => [item.name, item.settings?.isRequiredForExport === true]) ?? []),
        ...(fullConfiguration?.parameter?.question?.map((item) => [item.name, item.settings?.isRequiredForExport === true]) ?? []),
    ] as [string, boolean][];
    
    // Convert array of entries to object
    const columnVisibility = Object.fromEntries(parameterEntries.map(([name, isRequired]) => {
        return [name, isRequired || false];
    }));
    console.log(columnVisibility)
    return columnVisibility;
}